import { HttpMethod } from '@vision/ui/enums';
import { TicketReportingOptionsArgs } from '@vision/ui/interfaces';
import { buildEndpointWithQuery } from '@vision/ui/utils';
import { TicketManagerApiRequest } from '../ticket-manager.api';

const TICKET_REPORTING_OPTION_PATHS: Record<TicketReportingOptionsArgs['resource'], string> = {
  statuses: 'ticket_statuses',
  pools: 'pools',
  teams: 'teams',
  root_causes: 'root_causes',
};

export function buildGetTicketReportingOptionsRequest({
  accountId,
  query,
  resource,
}: TicketReportingOptionsArgs): TicketManagerApiRequest {
  const searchParams = new URLSearchParams({ account_id: accountId });
  new URLSearchParams(query).forEach((value, key) => searchParams.append(key, value));

  return {
    method: HttpMethod.GET,
    url: buildEndpointWithQuery(`/v2/inner_loop/${TICKET_REPORTING_OPTION_PATHS[resource]}`, searchParams.toString()),
  };
}
